var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "sendtypesetting"
  }, [_c("a-card", {
    attrs: {
      bordered: false
    }
  }, [_c("a-table", {
    attrs: {
      loading: _vm.isTableLoading,
      "data-source": _vm.tableDataList,
      rowKey: "id",
      pagination: false
    }
  }, [_c("a-table-column", {
    attrs: {
      "data-index": "name",
      align: "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(text, record) {
        return [_c("a-tooltip", [_c("template", {
          slot: "title"
        }, [_vm._v(" " + _vm._s(text) + " ")]), _vm._v(" " + _vm._s(text) + " ")], 2)];
      }
    }])
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t("sendtypesetting.sendtypeName")) + " "), _c("a-tooltip", [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.defaultLangObj.langName) + " ")]), _c("a-icon", {
    attrs: {
      type: "info-circle"
    }
  })], 2)], 1)]), _c("a-table-column", {
    attrs: {
      "data-index": "transportStatus",
      title: _vm.$t("publicuse.status"),
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(text, record) {
        return [_c("a-tag", {
          attrs: {
            color: record.transportStatus ? "red" : "blue"
          }
        }, [_vm._v(_vm._s(record.transportStatus ? _vm.$t("publicuse.disabled") : _vm.$t("publicuse.enable")))])];
      }
    }])
  }), _c("a-table-column", {
    attrs: {
      "data-index": "pictureUrl",
      title: _vm.$t("sendtypesetting.pictureUrl"),
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(text, record) {
        return [_c("img", {
          staticStyle: {
            width: "100px",
            height: "100px"
          },
          attrs: {
            src: record.host + record.pictrueUrl
          }
        })];
      }
    }])
  }), _c("a-table-column", {
    attrs: {
      title: _vm.$t("sendtypesetting.goodsNum"),
      "data-index": "goodsNum",
      width: "12%",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(text, record) {
        return [_vm._v(" " + _vm._s(text) + " ")];
      }
    }])
  }), _c("a-table-column", {
    attrs: {
      title: _vm.$t("publicuse.updatetime"),
      "data-index": "lastUpdateTime",
      width: "16%"
    }
  }), _c("a-table-column", {
    attrs: {
      title: _vm.$t("publicuse.action"),
      align: "left",
      width: "12%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(text, record) {
        return [_c("a", {
          on: {
            click: function click($event) {
              return _vm.updata(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("publicuse.edit")))]), _c("a-divider", {
          attrs: {
            type: "vertical"
          }
        }), _c("a-popconfirm", {
          attrs: {
            title: record.transportStatus ? _vm.$t("public.sureEnable") : _vm.$t("public.sureStop"),
            "ok-text": _vm.$t("publicuse.determine"),
            "cancel-text": _vm.$t("publicuse.cancel")
          },
          on: {
            confirm: function confirm($event) {
              return _vm.confirm(record);
            }
          }
        }, [_c("a", [_vm._v(_vm._s(record.transportStatus ? _vm.$t("publicuse.enable") : _vm.$t("publicuse.disabled")))])])];
      }
    }])
  })], 1)], 1), _c("a-modal", {
    attrs: {
      title: _vm.textMap[_vm.dialogStatus],
      destroyOnClose: "",
      maskClosable: false
    },
    model: {
      value: _vm.visible,
      callback: function callback($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c("a-spin", {
    attrs: {
      spinning: _vm.queryLoading
    }
  }, [_c("a-form-model", {
    ref: "dataForm",
    attrs: {
      model: _vm.modalValue
    }
  }, [_vm._l(_vm.modalValue.langDataList, function (tempObj, index) {
    return [tempObj.required ? [_c("a-form-model-item", {
      attrs: {
        label: tempObj.titleName,
        prop: "langDataList." + index + ".title",
        rules: [{
          required: true,
          message: _vm.errTip,
          trigger: "blur"
        }]
      }
    }, [_c("a-input", {
      attrs: {
        allowClear: true,
        placeholder: _vm.$t("public.enterPlease"),
        maxLength: 100
      },
      model: {
        value: tempObj.title,
        callback: function callback($$v) {
          _vm.$set(tempObj, "title", $$v);
        },
        expression: "tempObj.title"
      }
    })], 1)] : [_c("a-form-model-item", {
      attrs: {
        label: tempObj.titleName
      }
    }, [_c("a-input", {
      attrs: {
        allowClear: true,
        placeholder: _vm.$t("public.enterPlease"),
        maxLength: 100
      },
      model: {
        value: tempObj.title,
        callback: function callback($$v) {
          _vm.$set(tempObj, "title", $$v);
        },
        expression: "tempObj.title"
      }
    })], 1)]];
  }), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("public.picture"),
      prop: "pictureUrl",
      rules: [{
        required: true,
        message: _vm.$t("public.uploadPictureProp"),
        trigger: "change"
      }]
    }
  }, [_c("a-upload", {
    staticClass: "avatar-uploader",
    staticStyle: {
      "margin-bottom": "-20px"
    },
    attrs: {
      name: "file",
      "list-type": "picture-card",
      "show-upload-list": false,
      action: _vm.action,
      "before-upload": _vm.beforeUpload,
      data: _vm.updateData
    },
    on: {
      change: _vm.handleChange
    }
  }, [_vm.imageUrl ? _c("img", {
    staticStyle: {
      width: "100px",
      height: "100px"
    },
    attrs: {
      src: _vm.imageUrl,
      alt: "avatar"
    }
  }) : _c("div", [_c("a-icon", {
    attrs: {
      type: _vm.loading ? "loading" : "plus"
    }
  })], 1)])], 1)], 2)], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    on: {
      click: function click($event) {
        return _vm.resetFormDate();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.cancel")))]), _vm.dialogStatus == "update" ? _c("a-button", {
    attrs: {
      loading: _vm.confirmLoading,
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.updateModal();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.determine")))]) : _vm._e()], 1)], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };